import React, { useState } from "react";
import { Input } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";

interface FloatingInputProps {
  label: string;
  icon?: React.ReactNode;
  type?: "text" | "password";
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FloatingInput: React.FC<FloatingInputProps> = ({
  label,
  icon,
  type = "text",
  value,
  onChange,
}) => {
  const [focused, setFocused] = useState(false);

  return (
    <div
      style={{
        position: "relative",
        marginBottom: "28px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          borderBottom: "2px solid rgba(0, 0, 0, 0.4)",
          paddingBottom: "6px",
          transition: "border-color 0.3s",
        }}
      >
        <span
          style={{
            fontSize: "20px",
            marginRight: "8px",
            color: "rgb(136, 66, 153)F",
          }}
        >
          {icon}
        </span>
        {type === "password" ? (
          <Input.Password
            bordered={false}
            value={value}
            onChange={onChange}
            onFocus={() => setFocused(true)}
            onBlur={(e) => setFocused(!!e.target.value)}
            style={{
              flex: 1,
              fontSize: "16px",
              fontWeight: 500,
              padding: 0,
              background: "transparent",
            }}
          />
        ) : (
          <Input
            bordered={false}
            value={value}
            onChange={onChange}
            onFocus={() => setFocused(true)}
            onBlur={(e) => setFocused(!!e.target.value)}
            style={{
              flex: 1,
              fontSize: "16px",
              fontWeight: 500,
              padding: 0,
              background: "transparent",
            }}
          />
        )}
      </div>

      <label
        style={{
          position: "absolute",
          left: icon ? "32px" : "0px",
          bottom: focused || value ? "40px" : "8px",
          fontSize: focused || value ? "12px" : "16px",
          color: focused ? "rgb(136, 66, 153)" : "rgba(0,0,0,0.5)",
          fontWeight: 500,
          pointerEvents: "none",
          transition: "all 0.2s ease",
        }}
      >
        {label}
      </label>
    </div>
  );
};

export default FloatingInput;